import useMediaSelectionActions from '@/actions/useMediaSelectionActions'
import { AudioSourceInfo, useUserContext } from '@/UserContext'
import { useState } from 'react'
import { useAppContext } from '@/AppContext'
import { useRoomContext } from '@/RoomContext'

export default function useComputerAudioSelectionController() {
    const { toggleAudioDeviceSelection } = useMediaSelectionActions()

    const [appState] = useAppContext()
    const [_userState, userDispatch] = useUserContext()

    const { setGlobalOutputDeviceToMuseAudioShare } = useMediaSelectionActions()

    const [isChanging, setIsChanging] = useState(false)

    const { autoChangeSystemAudioOutputDevice } = appState.appSettings

    const toggleComputerAudioSelection = (inp: AudioSourceInfo) => {
        if (!autoChangeSystemAudioOutputDevice) {
            toggleAudioDeviceSelection(inp)
            setIsChanging(false)
            return
        }

        if (isChanging) {
            return
        }

        setIsChanging(true)

        const result = toggleAudioDeviceSelection(inp)

        if (result.added) {
            userDispatch({
                type: 'update_media_selection',
                value: {
                    isGlobalOutputDeviceChangeUpdating: true,
                },
            })

            setTimeout(() => {
                setGlobalOutputDeviceToMuseAudioShare({ undoWhenScreenShareEnds: false })
                setTimeout(() => {
                    setIsChanging(false)
                }, 750)
            }, 250)
        } else {
            setTimeout(() => {
                setIsChanging(false)
            }, 1000)
        }
    }

    return { toggleComputerAudioSelection, isComputerAudioChanging: isChanging }
}
